import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose, withProps, withState, withHandlers } from 'recompose'

import { getRawViewState } from 'data'
import { selectors as ConfigSelectors } from 'data/config'

import { actions as ApplicationsActions } from 'data/applications'

import FocusNavigator from 'components/Utils/FocusNavigator'
import { Button, Text } from 'components/base'

import SearchBox from 'components/Invitations/SlackInvite/SearchBox'
import Entries from 'components/Invitations/SlackInvite/Entries'
import ModalBody from 'components/Utils/Modal/Body'
import withGetApplicationInviteSettings from 'components/Integrations/dataSync/withGetApplicationInviteSettings'
import { SlackIcon } from 'components/Utils/Icons'

class ShareToSlack extends Component {
  state = { channelToShare: null }
  updateState = channel => {
    this.setState({ channelToShare: channel })
  }
  render() {
    const {
      postInviteLink,
      note,
      viewState,
      onModalClose,
      ...childProps
    } = this.props
    const hasErrors = viewState.errors.size > 0
    const isLoading = viewState.loading.size > 0

    return (
      <ModalBody>
        <div className="margin-bottom-large">
          <div className="flexbox flexbox-align-center margin-bottom-large">
            <SlackIcon size={16} className="margin-right-medium" />
            <Text.Title>Invite people from Slack</Text.Title>
          </div>
          <div className="shade-10 line-height-larger font-size-large">
            This will post an invite link to the selected Slack channel.
          </div>
        </div>

        {!hasErrors && (
          <FocusNavigator>
            <div className="radius-normal border-small border-shade-30">
              <SearchBox {...childProps} />
              <Entries
                {...childProps}
                isLoading={isLoading}
                updateState={this.updateState}
                onSubmit={channel => postInviteLink(channel)}
              />
            </div>
          </FocusNavigator>
        )}

        <div className="flexbox margin-top-larger font-weight-medium flexbox-space-between">
          <Button.Secondary onClick={onModalClose}>Close</Button.Secondary>
          {this.state.channelToShare && (
            <Button.Primary
              onClick={() => postInviteLink(this.state.channelToShare)}
            >
              Send to {this.state.channelToShare.label}
            </Button.Primary>
          )}
        </div>
      </ModalBody>
    )
  }
}

const NotesShareToSlackConnected = compose(
  connect(
    (state, { noteId }) => {
      const viewState = getRawViewState(state, 'loadSlackChannels')

      return {
        viewState,
        clientId: ConfigSelectors.getSlackAppSliteClientId(state),
      }
    },
    {
      postInviteLink: ApplicationsActions.postInviteLink,
    }
  ),
  withState('channels', 'setChannels', []),
  withGetApplicationInviteSettings({
    viewName: 'loadSlackChannels',
    onInviteSettingsFetched: ({ setChannels }, { targets }) => {
      setChannels(targets[0].options)
    },
  }),
  withState('query', 'setQuery', ''),
  withHandlers({
    onChange: ({ setQuery, query }) => query => setQuery(query),
  }),
  withProps(({ postInviteLink, ...props }) => ({
    ...props,
    postInviteLink(channel) {
      props.onModalClose()
      postInviteLink({
        target: {
          channel: channel.value,
        },
        clientId: props.clientId,
      })
    },
  }))
)(ShareToSlack)

export default NotesShareToSlackConnected
